import React, { Component } from 'react';
import "./Resume.css";

class LeftHeader extends Component {
    render() {
        return (
            <div className="col-md-4 left_header">

                        <strong>
                            <p className="header_p">Charles W. Roberts</p>
                            <p className="header_p">Norcross, GA 30093</p>
                        </strong>
                    </div>
        );
    }
} 

export default LeftHeader;





// WEBPACK FOOTER //
// ./src/components/Resume/LeftHeader.js